export default __webpack_public_path__ + "static/warehouse-management-system-9f730f5c9b6b52d15ae4d8e1f57024ce.png";